module.exports = __webpack_public_path__ + "static/media/impact-cybersoc.5c13b7e8.png";